import { wrapCreateBrowserRouter } from '@sentry/react';
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import {
  Adoration,
  Camino,
  DioceseInfo,
  DirectMessages,
  FacilitySched,
  Forms,
  GroupAdmins,
  EvaSync,
  MassIntentions,
  Messaging,
  MinistryScheduler,
  MyParish,
  OrganizationAdmins,
  ProtectedRoute,
} from '@/components';
import {
  Backgrounds,
  ChurchAdmins,
  FormTemplates,
  Reports,
  Home,
  Login,
  MessageTemplates,
  NotFound,
  OrganizationDetail,
  Organizations,
  ShortCodes,
  SuggestedModules,
  SuperAdmins,
} from '@/pages';
import { ORGANIZATION_TAB, ROUTE_ALIASES, type RouteConfig } from '@/types';
import { AuthCallbackPage } from './AuthCallbackPage';

const publicRoutes: RouteConfig[] = [
  {
    path: ROUTE_ALIASES.AUTH_CALLBACK_PAGE,
    element: <AuthCallbackPage />,
  },
  {
    path: ROUTE_ALIASES.NOT_FOUND,
    element: <NotFound />,
  },
];

const loginRoute: RouteConfig[] = [
  {
    path: ROUTE_ALIASES.LOGIN,
    element: <Login />,
  },
];

const authenticatedRoutes: RouteConfig[] = [
  {
    path: ROUTE_ALIASES.HOME,
    element: <ProtectedRoute />,
    children: [
      {
        path: '',
        element: <Navigate to={ROUTE_ALIASES.ORGANIZATIONS} replace />,
      },
      {
        path: ROUTE_ALIASES.ORGANIZATIONS,
        element: <Organizations />,
      },
      {
        path: ROUTE_ALIASES.ORGANIZATION_DETAIL,
        element: <OrganizationDetail />,
        children: [
          {
            path: '',
            element: <Navigate to={ORGANIZATION_TAB.ORG_ADMINS} replace />,
          },
          { path: ORGANIZATION_TAB.ORG_ADMINS, element: <OrganizationAdmins /> },
          { path: ORGANIZATION_TAB.GROUP_ADMINS, element: <GroupAdmins /> },
          { path: ORGANIZATION_TAB.MPA, element: <MyParish /> },
          { path: ORGANIZATION_TAB.MINISTRY_SCHEDULER, element: <MinistryScheduler /> },
          { path: ORGANIZATION_TAB.MASS_INTENTIONS, element: <MassIntentions /> },
          { path: ORGANIZATION_TAB.ADORATION, element: <Adoration /> },
          { path: ORGANIZATION_TAB.FACILITY_SCHED, element: <FacilitySched /> },
          { path: ORGANIZATION_TAB.CAMINO, element: <Camino /> },
          { path: ORGANIZATION_TAB.DIOCESE_INFO, element: <DioceseInfo /> },
          { path: ORGANIZATION_TAB.MESSAGING, element: <Messaging /> },
          { path: ORGANIZATION_TAB.DIRECT_MESSAGES, element: <DirectMessages /> },
          { path: ORGANIZATION_TAB.FORMS, element: <Forms /> },
          { path: ORGANIZATION_TAB.EVA_SYNC, element: <EvaSync /> },
        ],
      },
      {
        path: ROUTE_ALIASES.SHORT_CODES,
        element: <ShortCodes />,
      },
      {
        path: ROUTE_ALIASES.STATISTICS,
        element: <Home />,
      },
      {
        path: ROUTE_ALIASES.BACKGROUNDS,
        element: <Backgrounds />,
      },
      {
        path: ROUTE_ALIASES.SUPER_ADMINS,
        element: <SuperAdmins />,
      },
      {
        path: ROUTE_ALIASES.CHURCH_ADMINS,
        element: <ChurchAdmins />,
      },
      {
        path: ROUTE_ALIASES.SUGGESTED_MODULES,
        element: <SuggestedModules />,
      },
      {
        path: ROUTE_ALIASES.MESSAGE_TEMPLATES,
        element: <MessageTemplates />,
      },
      {
        path: ROUTE_ALIASES.FORM_TEMPLATES,
        element: <FormTemplates />,
      },
      {
        path: ROUTE_ALIASES.REPORTS,
        element: <Reports />,
      },
    ],
  },
];

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);
const appRouter = sentryCreateBrowserRouter([...authenticatedRoutes, ...loginRoute, ...publicRoutes]);

export const Routes = () => <RouterProvider router={appRouter} />;
